module.exports = __webpack_public_path__ + "img/3.27991fe8.jpg";